import {
  Alert,
  Box,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import { useEffect, useState } from "react";
import { OpenAPI } from "../../services/openapi";
import { PDFObject } from "react-pdfobject";
import { fetchPdfPreview } from "../../utils/documentPreview";

interface IDialogShowPDFProps {
  onClose: Function;
  open: boolean;
  url: string;
}

export function DialogShowPDF({ onClose, open, url }: IDialogShowPDFProps) {
  const handleClose = () => {
    setUrlTmp("");
    onClose();
  };

  const [urlTmp, setUrlTmp] = useState<string>("");
  const [error, setError] = useState<string>("");

  useEffect(() => {
    if (!open) {
      return;
    }

    const abortController = new AbortController();
    let objectUrl = "";
    setUrlTmp("");
    setError("");

    const urlLink =
      OpenAPI.BASE + "/doc/getFile/?id=" + encodeURIComponent(url);
    fetchPdfPreview(urlLink, abortController.signal)
      .then((previewUrl) => {
        objectUrl = previewUrl;
        setUrlTmp(previewUrl);
      })
      .catch((previewError: unknown) => {
        if (abortController.signal.aborted) {
          return;
        }
        setError(
          previewError instanceof Error
            ? previewError.message
            : "Das Dokument konnte nicht geöffnet werden."
        );
      });

    return () => {
      abortController.abort();
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
      }
    };
  }, [url, open]);

  return (
    <Dialog
      onClose={handleClose}
      fullWidth
      open={open}
      maxWidth={"xl"}
      style={{
        maxHeight: "80vh",
        height: "80vh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <DialogTitle><Box sx={{display:"flex",flexDirection:'row'}}>
<Box sx={{flex:1}}>Schnellansicht</Box>
        <IconButton onClick={() => handleClose()}>
          <Close></Close>
        </IconButton>
        </Box></DialogTitle>
      <DialogContent sx={{ height: "80vh",display:'flex', flexDirection:'column' }}>
        
        {error !== "" ? (
          <Alert severity="error">{error}</Alert>
        ) : urlTmp === "" ? (
          <Box sx={{flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
            <CircularProgress />
          </Box>
        ) : (
          <Box sx={{flex:1}}>
            <div
              id="testPDF"
              style={{
                // position: "fixed",
                // top: "0px",
                // left: "0px",
                flex: 1,
                width: "100%",
                height: "100%",
                zIndex: 300000,
                // backgroundColor: "green",
              }}
            >
              <PDFObject containerId={"testPDF"} height="100%" width="100%" url={urlTmp} pdfOpenParams={{view:'FitH'}}/>
            </div>
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
}
